import { z } from 'zod';

import {
  recommendShipmentRangeEndReasonValues,
  recommendShipmentRangeStartReasonValues,
  recommendShipmentRangeStatusValues,
  recommendShipmentRangeUnavailableReasonValues,
  SHIPMENT_RANGE_OPERATIONAL_DAY_START_LOCAL_TIME,
  type RecommendShipmentRangeRequest,
  type RecommendShipmentRangeResponse,
} from './recommend-shipment-range.dto.js';
import { IsoDateTimeSchema, RcScopeTypeSchema } from './shipments-types.js';

const BusinessDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const RecommendShipmentRangeRequestSchema: z.ZodType<RecommendShipmentRangeRequest> = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid(),
    storeId: z.uuid().optional(),
    locationId: z.uuid().optional(),
    materialId: z.uuid(),
    shipmentId: z.uuid().optional(),
  })
  .strict();

export const RecommendShipmentRangeResponseSchema: z.ZodType<RecommendShipmentRangeResponse> = z
  .object({
    status: z.enum(recommendShipmentRangeStatusValues),
    rcScopeType: RcScopeTypeSchema,
    rcScopeId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    timeZone: z.string().trim().min(1).nullable(),
    operationalDayStartLocalTime: z.literal(SHIPMENT_RANGE_OPERATIONAL_DAY_START_LOCAL_TIME),
    recommendedStartAt: IsoDateTimeSchema.nullable(),
    recommendedEndAt: IsoDateTimeSchema.nullable(),
    startReason: z.enum(recommendShipmentRangeStartReasonValues).nullable(),
    endReason: z.enum(recommendShipmentRangeEndReasonValues).nullable(),
    oldestAvailableOccurredAt: IsoDateTimeSchema.nullable(),
    previousCutoffAt: IsoDateTimeSchema.nullable(),
    lastClosedBusinessDate: BusinessDateSchema.nullable(),
    lastClosedAt: IsoDateTimeSchema.nullable(),
    includeTodayEndAt: IsoDateTimeSchema.nullable(),
    unavailableReason: z.enum(recommendShipmentRangeUnavailableReasonValues).optional(),
  })
  .strict();
